<template>
  <div class="card">
    <div class="card-body">
      <!-- Shop info -->
      <div class="shop-info">
        <div class="shop-info-item">
          <span class="shop-info-label">店舗名</span>
          <span class="shop-info-value">{{ data.shop_name }}</span>
        </div>
        <div class="shop-info-item">
          <span class="shop-info-label">管理者</span>
          <span class="shop-info-value">
            <span v-for="(staff, i) in filteredStaff" :key="staff.id">
              {{ staff.name }}<span v-if="i < filteredStaff.length - 1">、</span>
            </span>
          </span>
        </div>
        <div class="shop-info-item">
          <span class="shop-info-label">スタッフ数</span>
          <span class="shop-info-value">{{ data.number_of_staff }}名</span>
        </div>
        <div class="shop-info-item">
          <span class="shop-info-label">勤務状況</span>
          <span class="shop-info-value">{{ currentDate }}</span>
        </div>
      </div>

      <!-- Staff table -->
      <div class="table-responsive mt-4">
        <table class="table table-hover staff-table">
          <thead>
            <tr>
              <th>スタッフ名</th>
              <th class="text-center">出勤</th>
              <th class="text-center">退勤</th>
              <th class="text-center">ステータス</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="staff in data.staff" :key="staff.id">
              <td class="staff-name">{{ staff.name }}</td>
              <td class="text-center">
                <span :class="getTimecardInfo(staff).statusIn">
                  {{ getTimecardInfo(staff).time_start }}
                </span>
              </td>
              <td class="text-center">
                <span :class="getTimecardInfo(staff).statusOut">
                  {{ getTimecardInfo(staff).time_stop }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="getTimecardInfo(staff).paid_leave" class="badge badge-paid-leave">
                  {{ getTimecardInfo(staff).paid_leave }}
                </span>
                <span v-else :class="getTimecardInfo(staff).statusBadgeClass">
                  {{ getTimecardInfo(staff).statusLabel }}
                </span>
              </td>
            </tr>
            <tr v-if="!data.staff || data.staff.length === 0">
              <td colspan="4" class="text-center text-muted py-4">スタッフデータがありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        staff: [],
      },
      currentDate: new Date(),
    }
  },
  computed: {
    filteredStaff() {
      return this.data.staff.filter(staff => staff.pivot.manager_flag);
    },
    getTimecardInfo() {
      return (staff) => {
        const hasTimecard = !!staff.timecard[0];
        const hasPunchIn = hasTimecard && !!staff.timecard[0].time_start;
        const hasPunchOut = hasTimecard && !!staff.timecard[0].time_stop;

        let statusLabel = '未出勤';
        let statusBadgeClass = 'badge badge-not-working';
        if (hasPunchIn && hasPunchOut) {
          statusLabel = '退勤済';
          statusBadgeClass = 'badge badge-done';
        } else if (hasPunchIn) {
          statusLabel = '勤務中';
          statusBadgeClass = 'badge badge-working';
        }

        return {
          paid_leave: staff.paid_leaves[0] ? '有給休暇' : null,
          time_start: hasPunchIn ? staff.timecard[0].time_start : '---',
          time_stop: hasPunchOut ? staff.timecard[0].time_stop : hasPunchIn ? '未' : '---',
          statusIn: staff.timecard[0]?.timeInStatus ? 'text-primary' : hasTimecard ? 'text-warning' : 'text-muted',
          statusOut: staff.timecard[0]?.timeOutStatus ? 'text-primary' : hasTimecard ? 'text-warning' : 'text-muted',
          statusLabel,
          statusBadgeClass,
        };
      };
    },
  },
  mounted() {
    this.currentDate = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth()+1) + '-' + this.currentDate.getDate();
    this.getShopDetails();
  },
  methods: {
    getShopDetails () {
      const shop_id = this.$store.getters.shop;
      this.$http.get(process.env.VUE_APP_API_PATH + '/shop/timecardList/' + shop_id + '/' + this.currentDate)
      .then(response => {
        this.data = response.data.data;
        this.data.number_of_staff = this.data.staff.length;
      })
      .catch(error => {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped>
  /* Shop info bar */
  .shop-info {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 32px;
    padding: 16px 20px;
    background-color: #f7fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
  }

  .shop-info-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .shop-info-label {
    font-size: 13px;
    font-weight: 700;
    color: #718096;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
  }

  .shop-info-value {
    font-size: 16px;
    font-weight: 600;
    color: #1a202c;
  }

  /* Staff table */
  .staff-table thead th {
    font-size: 14px;
    font-weight: 700;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 2px solid #e2e8f0;
    padding: 14px 16px;
    background-color: #f7fafc;
  }

  .staff-table tbody td {
    padding: 14px 16px;
    font-size: 15px;
    vertical-align: middle;
    border-color: #edf2f7;
  }

  .staff-table tbody tr:hover {
    background-color: #f0faf4;
  }

  .staff-name {
    font-weight: 600;
    color: #1a202c;
  }

  /* Status badges */
  .badge-working {
    background-color: #049C4C;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 4px;
  }

  .badge-done {
    background-color: #3182ce;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 4px;
  }

  .badge-not-working {
    background-color: #e2e8f0;
    color: #718096;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 4px;
  }

  .badge-paid-leave {
    background-color: #ed8936;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 4px;
  }
</style>
